<script setup>
import { ref, inject } from 'vue'
import { usePollStore } from '../stores/poll'
import EmojiSlider from './EmojiSlider.vue'
import PollLayout from './PollLayout.vue'

const pollParams = inject('pollParams')
const pollStore = usePollStore()

const sliderValue = ref(pollStore.voteValue || 50)

const handleRelease = async (value) => {
  try {
    await pollStore.submitVote(value)
    sliderValue.value = pollStore.voteValue
  } catch (error) {
    console.error('Failed to submit vote:', error)
  }
}
</script>

<template>
  <PollLayout>
    <p v-if="pollParams.description" class="poll-view__description">
      {{ pollParams.description }}
    </p>

    <div class="poll-view__slider-container">
      <EmojiSlider
        v-model="sliderValue"
        :emoji="pollParams.emoji"
        :startLabel="pollParams.startLabel"
        :stopLabel="pollParams.stopLabel"
        :disabled="pollStore.isSubmitting"
        @release="handleRelease"
      />

      <p v-if="pollStore.isSubmitting" class="poll-view__submitting">Aan het stemmen...</p>

      <p v-if="pollStore.hasVoted && !pollStore.isSubmitting" class="poll-view__success">
        ✓ Je stem is verzonden
      </p>

      <p v-if="pollStore.error" class="poll-view__error">
        {{ pollStore.error }}
      </p>
    </div>
  </PollLayout>
</template>

<style scoped>
.poll-view__description {
  font-size: 1.125rem;
  margin-bottom: 2rem;
  color: #666;
}

.poll-view__slider-container {
  margin: 2rem 0;
}

.poll-view__submitting {
  text-align: center;
  margin-top: 1rem;
  font-size: 1rem;
  color: #666;
  font-style: italic;
}

.poll-view__success {
  text-align: center;
  margin-top: 1rem;
  font-size: 1rem;
  color: #4caf50;
  font-weight: 600;
}

.poll-view__error {
  color: #d32f2f;
  margin-top: 1rem;
  font-weight: 600;
  text-align: center;
}
</style>
